(() => {
document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
if (!slides.length) return;
let index = 0, start = null;
function show(value) {
index = (value + slides.length) % slides.length;
slides.forEach((slide, i) => { slide.hidden = i !== index; if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause()); });
thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
const counter = gallery.querySelector('[data-gallery-counter]');
if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
}
thumbs.forEach((thumb,i) => thumb.addEventListener('click', () => show(i)));
gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => show(index - 1));
gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
gallery.addEventListener('gallery:select', event => show(event.detail));
gallery.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); } });
const stage = gallery.querySelector('.gallery-stage');
stage.addEventListener('touchstart', event => { start = event.touches[0].clientX; }, {passive:true});
stage.addEventListener('touchend', event => { if (start !== null) { const delta = event.changedTouches[0].clientX - start; if (Math.abs(delta) > 50) show(index + (delta < 0 ? 1 : -1)); start = null; } }, {passive:true});
show(0);
});
})();